module.exports = __webpack_public_path__ + "static/media/rfjk.d1e690ff.png";